module.exports = __webpack_public_path__ + "img/about_yourself.9e2f9151.svg";